import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\PaperController::index
* @see Http/Controllers/PaperController.php:25
* @route '/projects/{project}/articles'
*/
export const index = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/articles',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PaperController::index
* @see Http/Controllers/PaperController.php:25
* @route '/projects/{project}/articles'
*/
index.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return index.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PaperController::index
* @see Http/Controllers/PaperController.php:25
* @route '/projects/{project}/articles'
*/
index.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PaperController::index
* @see Http/Controllers/PaperController.php:25
* @route '/projects/{project}/articles'
*/
index.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PaperController::index
* @see Http/Controllers/PaperController.php:25
* @route '/projects/{project}/articles'
*/
const indexForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PaperController::index
* @see Http/Controllers/PaperController.php:25
* @route '/projects/{project}/articles'
*/
indexForm.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PaperController::index
* @see Http/Controllers/PaperController.php:25
* @route '/projects/{project}/articles'
*/
indexForm.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\PaperController::bulkDelete
* @see Http/Controllers/PaperController.php:197
* @route '/projects/{project}/articles/bulk-delete'
*/
export const bulkDelete = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkDelete.url(args, options),
    method: 'post',
})

bulkDelete.definition = {
    methods: ["post"],
    url: '/projects/{project}/articles/bulk-delete',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\PaperController::bulkDelete
* @see Http/Controllers/PaperController.php:197
* @route '/projects/{project}/articles/bulk-delete'
*/
bulkDelete.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return bulkDelete.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PaperController::bulkDelete
* @see Http/Controllers/PaperController.php:197
* @route '/projects/{project}/articles/bulk-delete'
*/
bulkDelete.post = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkDelete.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\PaperController::bulkDelete
* @see Http/Controllers/PaperController.php:197
* @route '/projects/{project}/articles/bulk-delete'
*/
const bulkDeleteForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulkDelete.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\PaperController::bulkDelete
* @see Http/Controllers/PaperController.php:197
* @route '/projects/{project}/articles/bulk-delete'
*/
bulkDeleteForm.post = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulkDelete.url(args, options),
    method: 'post',
})

bulkDelete.form = bulkDeleteForm

/**
* @see \App\Http\Controllers\PaperController::show
* @see Http/Controllers/PaperController.php:170
* @route '/projects/{project}/articles/{article}'
*/
export const show = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/articles/{article}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PaperController::show
* @see Http/Controllers/PaperController.php:170
* @route '/projects/{project}/articles/{article}'
*/
show.url = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            project: args[0],
            article: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
        article: typeof args.article === 'object'
        ? args.article.id
        : args.article,
    }

    return show.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace('{article}', parsedArgs.article.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PaperController::show
* @see Http/Controllers/PaperController.php:170
* @route '/projects/{project}/articles/{article}'
*/
show.get = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PaperController::show
* @see Http/Controllers/PaperController.php:170
* @route '/projects/{project}/articles/{article}'
*/
show.head = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PaperController::show
* @see Http/Controllers/PaperController.php:170
* @route '/projects/{project}/articles/{article}'
*/
const showForm = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PaperController::show
* @see Http/Controllers/PaperController.php:170
* @route '/projects/{project}/articles/{article}'
*/
showForm.get = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PaperController::show
* @see Http/Controllers/PaperController.php:170
* @route '/projects/{project}/articles/{article}'
*/
showForm.head = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\PaperController::destroy
* @see Http/Controllers/PaperController.php:184
* @route '/projects/{project}/articles/{article}'
*/
export const destroy = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/projects/{project}/articles/{article}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\PaperController::destroy
* @see Http/Controllers/PaperController.php:184
* @route '/projects/{project}/articles/{article}'
*/
destroy.url = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            project: args[0],
            article: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
        article: typeof args.article === 'object'
        ? args.article.id
        : args.article,
    }

    return destroy.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace('{article}', parsedArgs.article.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PaperController::destroy
* @see Http/Controllers/PaperController.php:184
* @route '/projects/{project}/articles/{article}'
*/
destroy.delete = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\PaperController::destroy
* @see Http/Controllers/PaperController.php:184
* @route '/projects/{project}/articles/{article}'
*/
const destroyForm = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\PaperController::destroy
* @see Http/Controllers/PaperController.php:184
* @route '/projects/{project}/articles/{article}'
*/
destroyForm.delete = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\PaperController::files
* @see Http/Controllers/PaperController.php:213
* @route '/projects/{project}/articles/{article}/files'
*/
export const files = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: files.url(args, options),
    method: 'get',
})

files.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/articles/{article}/files',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PaperController::files
* @see Http/Controllers/PaperController.php:213
* @route '/projects/{project}/articles/{article}/files'
*/
files.url = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            project: args[0],
            article: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
        article: typeof args.article === 'object'
        ? args.article.id
        : args.article,
    }

    return files.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace('{article}', parsedArgs.article.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PaperController::files
* @see Http/Controllers/PaperController.php:213
* @route '/projects/{project}/articles/{article}/files'
*/
files.get = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: files.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PaperController::files
* @see Http/Controllers/PaperController.php:213
* @route '/projects/{project}/articles/{article}/files'
*/
files.head = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: files.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PaperController::files
* @see Http/Controllers/PaperController.php:213
* @route '/projects/{project}/articles/{article}/files'
*/
const filesForm = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: files.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PaperController::files
* @see Http/Controllers/PaperController.php:213
* @route '/projects/{project}/articles/{article}/files'
*/
filesForm.get = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: files.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PaperController::files
* @see Http/Controllers/PaperController.php:213
* @route '/projects/{project}/articles/{article}/files'
*/
filesForm.head = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: files.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

files.form = filesForm

/**
* @see \App\Http\Controllers\PaperController::updateScreening
* @see Http/Controllers/PaperController.php:224
* @route '/projects/{project}/articles/{article}/screening'
*/
export const updateScreening = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: updateScreening.url(args, options),
    method: 'patch',
})

updateScreening.definition = {
    methods: ["patch"],
    url: '/projects/{project}/articles/{article}/screening',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\PaperController::updateScreening
* @see Http/Controllers/PaperController.php:224
* @route '/projects/{project}/articles/{article}/screening'
*/
updateScreening.url = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            project: args[0],
            article: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
        article: typeof args.article === 'object'
        ? args.article.id
        : args.article,
    }

    return updateScreening.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace('{article}', parsedArgs.article.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PaperController::updateScreening
* @see Http/Controllers/PaperController.php:224
* @route '/projects/{project}/articles/{article}/screening'
*/
updateScreening.patch = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: updateScreening.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\PaperController::updateScreening
* @see Http/Controllers/PaperController.php:224
* @route '/projects/{project}/articles/{article}/screening'
*/
const updateScreeningForm = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateScreening.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\PaperController::updateScreening
* @see Http/Controllers/PaperController.php:224
* @route '/projects/{project}/articles/{article}/screening'
*/
updateScreeningForm.patch = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateScreening.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

updateScreening.form = updateScreeningForm

const PaperController = { index, bulkDelete, show, destroy, files, updateScreening }

export default PaperController